import { graphql, useStaticQuery } from 'gatsby';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

type ContentFrontMatterProps = {
  title: string;
  date: Date;
  slug: string;
  code: string;
  published: boolean;
  category: string;
  tags: string[];
  featuredImage:FileNode;
  embeddedImagesLocal: [FileNode];
  description: string;
};

export interface ContentCardProps {
  id: string;
  frontmatter: ContentFrontMatterProps;
}
interface ContentProps {
  contentItems: ContentCardProps[];
}
const contentQuery = () => {
  const data = useStaticQuery(graphql`
    query ContentQuery {
      premiumContent: allMdx(
        sort: { frontmatter: { date: ASC } }
        filter: { frontmatter: { category: { eq: "content" } } }
        limit: 1000
      ) {
        contentItems: nodes {
          id
          frontmatter {
            title
            date(formatString: "MMM Do, YYYY")
            code
            slug
            published
            category
            tags
            description
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
            embeddedImagesLocal {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
          }
          internal {
            contentFilePath
          }
        }
      }
    }
  `);
  const content: ContentProps = data.premiumContent;
  return { content };
};



export { contentQuery };
